import React, { useContext } from 'react';
import styled from '@emotion/styled';
import IcomoonIcon from '../../../shared/IcomoonIcon';
import { color, formStyles, breakpoints } from '../../../../utils/style';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import PopupWindow, { invokePopup } from '../../../../components/shared/PopupWindow';
import Star1 from './StarIcons/Star1';
import Star2 from './StarIcons/Star2';
import Star3 from './StarIcons/Star3';
import Star4 from './StarIcons/Star4';
import Star5 from './StarIcons/Star5';
import { Logout } from '../../../Auth/Auth';
import { withdrawRequestUrl } from './Config';
import StoreContext from '../../../shared/Context/StoreContext';
import { getAuthToken, getAuthHeader } from '../../../Auth/Utils';

const Wrapper = styled('div')`
  ${formStyles}
  position: relative;
  padding: 0 0 20px;
  .loading {
    position:relative;
  }
  .loading::before {
    content: "";
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background: ${color.black};
    opacity:0.7;
    z-index: 1;
  }
  .two-fields {
    .fieldWrap {
      width: 48%;
      display: inline-block;
      vertical-align: top;
    }
  }
  .red-button {
    float: right;
  }
  
  .green-button {
    margin: 0;
  }
  
  .fieldWrap .error {
    top: 43px;
  }
  
  .rating {
    float: left;
  }
  .rating input {
    display: none;
  }
  .rating label {
    display: inline-block;
    cursor: pointer;
    color: rgb(77, 77, 77);
    font-size:30px;
    float: right;
    height: 40px;
    width: 40px;
    margin: 0;
    position:relative;
    &::after {
      content: "★";
      width: 40px;
      height:30px;
      display:inline-block;
      text-align:center;
      position: absolute;
      top: 0;
      left: 0;
    }
    span {
      text-indent: 100%;
      white-space: nowrap;
      overflow: hidden;
      display: block;
      width: 0;
    }
  }
  
 
  .rating > input:checked ~ label,
  .rating:not(:checked) > label:hover,
  .rating:not(:checked) > label:hover ~ label { color: ${color.orange};  }
  
  .rating > input:checked + label:hover,
  .rating > input:checked ~ label:hover,
  .rating > label:hover ~ input:checked ~ label,
  .rating > input:checked ~ label:hover ~ label { color: ${color.yellow};  } 
  @media (max-width: ${breakpoints.lg}) {
    width:100%;
    float:none;
    margin: 20px 0;
    .rating label {
      font-size:36px;
      width: 48px;
      height:48px;
      &::after {
        width: 48px;
        height:48px;
      }
    }
  }
`;

const StarFieldset = styled('fieldset')`
  border: none;
  float: left;
  padding: 20px 0 10px;
  legend {
    color: ${color.textGrey};
  }
  label {
    width: 36px;
    height: 36px;
    display: inline-block;
    border: 1px solid rgb(77, 77, 77);
    text-indent: -9999px;
    overflow: hidden;
    border-radius: 20px;
    margin-right: 5px;
    cursor: pointer;
    padding: 0 !important;
    float: left;
    &:hover {
      border-color: ${color.white};
    }
  }
  
  input[type="radio"]:checked+label {
    border-color: ${color.yellow}
  }
  
  input[type="radio"] {
    display: none;
  }
`;

const AllStarWrapper = styled('div')`
  position: relative;
  height: 36px;
  width: 205px;
`;

const StarInputs = styled('div')`
  position: relative;
  z-index: 1;
`;

const StarContainer = styled('div')`
  position: absolute;
  left: 0;
  right: 0;
  height: 36px;
  width: 205px;
`;

const OneStar = styled('div')`
  float: left;
  width:36px;
  height:36;
  padding: 2px;
  margin-right: 5px;
`;


const MsgWrap = styled('div')`
  margin-bottom: 30px;
  span {
    display:none;
    background-color:${color.yellow};
    color: ${color.black};
    padding:5px 10px;
    text-align:center;
    &.visible {
      display: block;
    }
  }
  h2, a {
    color: orange;
  }
  &.successMsg {
    display: none;
    &.visible {
      display: block;
      & + .game-withdraw-form, & + .withdraw-popup-window-title {
        display: none;
      }
    }
    .call-link {
      cursor: pointer;
    }
  }
`;

const WithdrawFormOpen = (event, popupId) => {
  invokePopup(event, popupId);
};

const showErrorMsg = (msg) => {
  const errorMsg = document.getElementById('withdrawErrorMsg');
  errorMsg.innerText = msg;
  errorMsg.classList.add('visible');
};

const showSuccessMsg = () => {
  const errorMsg = document.getElementById('withdrawErrorMsg');
  errorMsg.classList.remove('visible');
  const successMsg = document.getElementById('withdrawSuccessMsg');
  successMsg.classList.add('visible');
  const popupTitle = document.getElementById('withdraw-popup-window-title');
  popupTitle.style.display = 'none';
};

// Radio input
const RadioButton = ({ field: { name, value, onChange, onBlur }, id, label, ...props }) => (
  <>
    <input
      name={name}
      id={id}
      type="radio"
      value={id} // could be something else for output?
      checked={id === value}
      onChange={onChange}
      onBlur={onBlur}
      {...props}
    />
    <label htmlFor={id}><span>{label}</span></label>
  </>
);


// Radio group
const RadioButtonGroup = ({
                            value, error, touched, id,
                            label, children
                          }) => {
  return (
    <StarFieldset className="emoji">
      <legend>{label}</legend>
      <AllStarWrapper>
        <StarContainer>
          <OneStar>
            <Star1 text="smiley"/>
          </OneStar>
          <OneStar>
            <Star2 text="crazy"/>
          </OneStar>
          <OneStar>
            <Star3 text="cowboy"/>
          </OneStar>
          <OneStar>
            <Star4 text="devil"/>
          </OneStar>
          <OneStar>
            <Star5 text="love"/>
          </OneStar>
        </StarContainer>
        <StarInputs>
          {children}
        </StarInputs>
      </AllStarWrapper>

    </StarFieldset>
  );
};

const StarFieldsetStars = styled('fieldset')`
  border: none;
  padding: 0 0 20px;
  clear: left;
`;


// Radio group
const RadioButtonGroupStars = ({
                                 value, error, touched, id,
                                 label, children
                               }) => {
  return (
    <StarFieldsetStars className="rating">
      <legend>{label}</legend>
      {children}
    </StarFieldsetStars>
  );
};

const initialValues = {
  username: '',
  comment: '',
  rating: '',
  emoji: '',
};

const FormBody = ({ popupId }) => {
  const StoreContextValue = useContext(StoreContext);
  const setUsernameCallback = StoreContextValue.setUsernameCallback;
  const onSubmit = async (values, { resetForm }) => {
    if (!getAuthToken) {
      return false;
    }
    let body = JSON.stringify(values);
    const response = await fetch(withdrawRequestUrl, {
      method: 'POST',
      body: body,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthHeader()
      },
    });
    if (response.ok) {
      let json = await response.json();
      if (json.error && json.message) {
        showErrorMsg(json.message);
        resetForm({});
        console.log(json.message);
        if (json.error_type === 'session_expired') {
          Logout(false, setUsernameCallback);
        }
      } else {
        showSuccessMsg();
        resetForm({});
      }

    } else {
      console.log("Withdraw Error HTTP: " + response.status);
      let json = await response.json();
      if (json.code === 'jwt_auth_invalid_token') {
        Logout(false, setUsernameCallback);
      }

    }
  };

  return (
    <Wrapper>
      <MsgWrap id="loginMsg">
        <span className="errorMsg" id="withdrawErrorMsg">
          Failed sending form. Please try again
        </span>
      </MsgWrap>
      <MsgWrap className="successMsg a-center" id="withdrawSuccessMsg">
        <h2>ติดต่อ Call Center</h2>
        <p>ระบบได้รับความคิดเห็นของคุณแล้ว</p>
        <p>กรุณาติดต่อ Call Center เพื่อรับเงินได้ที่</p>
        <p>
          <a
            href={process.env.LINE_ID}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Call"
            className="call-link"
          >
            Link
          </a>
        </p>
      </MsgWrap>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={Yup.object().shape({
          username: Yup.string().required("จำเป็นต้องระบุ"),
          comment: Yup.string()
            .min(100, "ขั้นต่ำ 100 อักขระ")
            .required("จำเป็นต้องระบุ"),
          rating: Yup.string().required("จำเป็นต้องระบุ"),
        })}
        >
        {({
          errors,
          status,
          touched,
          dirty,
          isValid,
          values,
        }) => (
          <Form id="withdrawForm" className="game-withdraw-form">
            <div className="labelField">
              <label htmlFor="username">ยูสเซอร์เนม</label>
              <div className="fieldWrap iconField">
                <IcomoonIcon icon="user" color={color.white} size={18} />
                {errors.username && touched.username && (
                  <div className="error-new">{errors.username}</div>
                )}
                <Field
                  type="text"
                  name="username"
                  className="username"
                  placeholder="ยูสเซอร์เนม (e.g. AOOG000)"
                  value={values.username || ""}
                />
              </div>
            </div>

            <div className="labelField">
              <label htmlFor="comment">ความคิดเห็นของคุณ</label>
              <div className="fieldWrap iconField">
                {errors.comment && errors.comment && touched.comment && (
                  <div className="error-new">! {errors.comment}</div>
                )}
                <Field
                  as="textarea"
                  id="comment"
                  name="comment"
                  placeholder="แสดงความคิดเห็นของคุณอย่างน้อย 100 ตัวอักษร"
                  value={values.comment || ""}
                />
              </div>
            </div>

            <RadioButtonGroup
              id="emoji"
              label="ความรู้สึกของคุณ"
              value={values.emoji}
              error={errors.emoji}
              touched={touched.emoji}
            >
              <Field
                component={RadioButton}
                name="emoji"
                id="smiley"
                label="5"
              />
              <Field
                component={RadioButton}
                name="emoji"
                id="crazy"
                label="4"
              />
              <Field
                component={RadioButton}
                name="emoji"
                id="cowboy"
                label="3"
              />
              <Field
                component={RadioButton}
                name="emoji"
                id="devil"
                label="2"
              />
              <Field component={RadioButton} name="emoji" id="love" label="1" />
            </RadioButtonGroup>
            {errors.emoji && touched.emoji && (
              <div className="error">! {errors.emoji}</div>
            )}

            <RadioButtonGroupStars
              id="rating"
              value={values.radioGroup}
              error={errors.radioGroup}
              touched={touched.radioGroup}
            >
              <Field
                component={RadioButton}
                name="rating"
                id="star5"
                label="5 stars"
              />
              <Field
                component={RadioButton}
                name="rating"
                id="star4"
                label="4 stars"
              />
              <Field
                component={RadioButton}
                name="rating"
                id="star3"
                label="3 stars"
              />
              <Field
                component={RadioButton}
                name="rating"
                id="star2"
                label="2 stars"
              />
              <Field
                component={RadioButton}
                name="rating"
                id="star1"
                label="1 star"
              />
            </RadioButtonGroupStars>
            {status && status.msg && <div>{status.msg}</div>}
            <div className="clear a-center">
              <button
                className="button transparent-button-orange"
                type="submit"
                disabled={!isValid || !dirty}
              >
                ส่งความคิดเห็นและรับเงิน
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Wrapper>
  )
};

const WithdrawForm = ({ popupId }) => {
  return (
    <PopupWindow title="ถอนเงิน" popupId={popupId} extraClass="a-left">
      <FormBody popupId={popupId}/>
    </PopupWindow>
  );
};

export default WithdrawForm;
export { WithdrawFormOpen };